import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getConfigCarpetaMandante = async (idMandante) => {
    try {
        const userInfo = fetchUser();
        const { data } = await Axios.get(
            `/carpetaconfigmandante?empresa=${userInfo.empresa}&idMandante=${idMandante}`
        );
        return data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const saveConfigCarpetaMandante = async (idMandante, docs) => {
    try {
        const userInfo = fetchUser();
        const { data } = await Axios.post('/carpetaconfigmandante/bulk', {
            empresa: userInfo.empresa,
            idMandante,
            docs,
        });
        return data;
    } catch (error) {
        return Promise.reject(error);
    }
};
